module.exports = require("normalize-url");